<div class="grid-container" [formGroup]="form">
    <ui-form-field class="grid-span-2" [label]="'PAGES.ALERT_SCENARIO_EDITION.WATER_LEAKAGE_FORM.SCENARIO_NAME' | translate">
        <input
            advizeoInput
            formControlName="name"
            [required]="true"
            [placeholder]="'PAGES.ALERT_SCENARIO_EDITION.WATER_LEAKAGE_FORM.SCENARIO_NAME_PLACEHOLDER' | translate"
        />
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>
</div>
